import React, { Component } from "react";
import { Link } from "react-router-dom";
import Action from "../../components/Action";
import Card from "../../components/Card";
import { TextareaQuestion } from "../../components/TextQuestion";
import List, { ListItem } from "../../components/List";
import ScrollToTop from "../../components/utils/ScrollToTop";

class ReferrerAnythingElse extends Component {
  constructor(props) {
    super(props);

    if (this.props.additionalInformation) {
      this.state = {
        additionalInformation: this.props.additionalInformation,
      };
    } else {
      this.state = {
        additionalInformation: "",
      };
    }
  }

  additionalInformationEntered = (ai) => {
    this.setState({ additionalInformation: ai });
  };

  saveAndSendQuote = () => {
    this.props.onStepComplete({
      additionalInformation: this.state.additionalInformation,
    });
  };

  render() {
    return (
      <React.Fragment>
        <ScrollToTop />
        <Card title="Anything that will help us get this moving? (optional)" removeTopPadding>
          <React.Fragment>
            <p>For example:</p>
            <List bullet>
              <ListItem>A second buyer or seller we should contact, with their name and number</ListItem>
              <ListItem>Whether an offer has been accepted</ListItem>
            </List>
          </React.Fragment>

          <TextareaQuestion
            question="Notes for our team"
            optional={true}
            value={this.state.additionalInformation}
            valueEntered={this.additionalInformationEntered}
          />

          {!this.props.showTermsLink ? null : (
            <p>
              By continuing you agree to
              <Link to="/refer/terms" target="_blank">
                {" "}
                our terms for referring clients to Juno
              </Link>
              .
            </p>
          )}

          <Action onClick={this.saveAndSendQuote}>{this.props.buttonText}</Action>
        </Card>
      </React.Fragment>
    );
  }
}

export default ReferrerAnythingElse;
